import React from 'react';
import { Route, IndexRoute } from 'react-router';

import RouterLayout from '../components/RouterLayout';
import LoginPage from '../components/LoginPage';
import wxLoginPage from '../components/wxLoginPage';

export default (
  <Route path="/" component={RouterLayout}>
    <IndexRoute component={LoginPage} />
    <Route component={wxLoginPage} path="wx-login"/>
  </Route>
)


// WEBPACK FOOTER //
// ./app/javascript/bundles/LoginPcApp/routes/routes.jsx